<template>
<div> 
  <main class="container-fluid"> 

  <div class='row heading'>
    <div class='col-4 px-3 pt-3 d-none d-md-flex'></div>
    <div class='col-16 px-3 pt-3'>
      <h1 class="title pt-2 mb-0">Wiki!</h1>
      <h1 class="title"><span v-text="$ml.get('wikiSubTitle')" class="pb-2">Nós ajudamos como podemos e como não podemos.</span></h1> 
    </div>
  </div>

  <section class='row'> 
    <div class='col-4 px-3 pb-3 align-self-start d-none d-md-flex'></div>

<!-- Início do menu mobile -->
    
    <b-sidebar 
      ref="sidebarMenu"
      id="sidebar-menu" 
      no-header 
      backdrop-variant="dark" 
      backdrop 
      shadow
      width='220px'
    > 

      <div class='card-header d-flex justify-content-between'>
        <a>Wiki</a>
        <a class="row justify-content-start pointer" @click="closeSidebarMenu" role="button">
          <img src="../../../../src/assets/icons/times-circle.svg" class="ico-15"/>
        </a>  
      </div>
  
      <aside class=' mt-1 pb-2'>  
        <ul class="none-p-m pt-3"> 
          <li class='pb-2'>
            <a v-text="$ml.get('programs')">Programas</a>
            <ul class='none-p-m pt-2 pb-3'>
              <li :class="this.menuSelected == 'lifeCicle' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('lifeCicle')" v-text="$ml.get('programLifeCycle')">
                  Ciclo de vida de um programa
                </a>
              </li>
              <li :class="this.menuSelected == 'publicOrPrivate' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('publicOrPrivate')" v-text="$ml.get('publicOrPrivateProgram')">
                  Programa público ou privado
                </a>
              </li>
              <li :class="this.menuSelected == 'whatBounty' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('whatBounty')" v-text="$ml.get('whatIsBugBounty')">
                  O que é Bug Bounty
                </a>
              </li> 
            </ul>
          </li>  

        </ul>
      </aside>
    
    </b-sidebar> 

 
    <a id="btn-float-mobile" class="d-md-none btn pointer" v-b-toggle.sidebar-menu role="button">
      <svg width="20" height="20" class="mb-1">       
        <image xlink:href="../../../../src/assets/icons/bars.svg" width="20" height="20"/>    
      </svg>
    </a>  
<!-- Fim -->

    <div class='col-4 col-md-4 mb-5 d-none d-md-flex'>
       <aside class='col'> 
        <ul class="none-p-m"> 
          <li class='pb-2'>
            <a v-text="$ml.get('programs')">Programas</a>
            <ul class='none-p-m pt-2 pb-3'>
              <li :class="this.menuSelected == 'lifeCicle' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('lifeCicle')" v-text="$ml.get('programLifeCycle')">
                  Ciclo de vida de um programa
                </a>
              </li>
              <li :class="this.menuSelected == 'publicOrPrivate' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('publicOrPrivate')" v-text="$ml.get('publicOrPrivateProgram')">
                  Programa público ou privado
                </a>
              </li>
              <li :class="this.menuSelected == 'whatBounty' ? 'active py-1' :'py-1'">
                <i><img src="../../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                <a @click="alterMenu('whatBounty')" v-text="$ml.get('whatIsBugBounty')">
                  O que é Bug Bounty
                </a>
              </li> 
            </ul>
          </li>  

        </ul>
      </aside>
    </div>

    <div class='col-24 px-3 col-md-12 pb-3 mb-5'> 
      <div class="card card-body">
       <life-cicle v-if="menuSelected == 'lifeCicle'"/>
       <public-or-private  v-if="menuSelected == 'publicOrPrivate'"/>
       <what-bounty v-if="menuSelected == 'whatBounty'"/> 
      </div>
    </div> 
  </section>
 
  </main>
</div>
</template>

<script>     
import LifeCicle from './program/lifeCicle.vue';
import PublicOrPrivate from './program/publicOrPrivate.vue';
import WhatBounty from './program/whatBounty.vue';
 
export default {
  components: { 
    LifeCicle,
    PublicOrPrivate,
    WhatBounty
  },
  data() {
    return {
      title: "Wiki",
      menuSelected: 'lifeCicle',
    };
  },
  mounted() {
    let params = this.$route.params
    if(params.item){
      this.alterMenu(params.item);
    } 
  },
  methods: {
    closeSidebarMenu(){
      this.$refs.sidebarMenu.hide(); 
    },
    alterMenu(menu) {
      this.menuSelected = menu;
      this.closeSidebarMenu();
    },
  },
};
</script>

<style scoped>
.active{
  color: #E10E71 !important; 
}
.active > a{ 
  font-weight: 500;
}
a{
  cursor: pointer;
}
a:active{
  color: #E10E71 !important;
}
 
</style>